document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".team-grid");

  blocks.forEach((block) => {
    initializeTeamGrid(block);
  });
});

document.addEventListener("blockEditorInit", function (event) {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".team-grid")) {
    initializeTeamGrid(block);
  }

  block.querySelectorAll(".team-grid").forEach((teamGridBlock) => {
    initializeTeamGrid(teamGridBlock);
  });
});

const TEAM_GRID_VISIBLE_CLASS = "team-grid__card--bio-visible";

function initializeTeamGrid(blockElement) {
  const cards = blockElement.querySelectorAll(".team-grid__card--has-bio");

  if (cards.length === 0) {
    return;
  }

  cards.forEach((card) => {
    initializeTeamGridCard(card);
  });
}

function initializeTeamGridCard(cardElement) {
  if (cardElement.dataset.teamGridInitialized === "true") {
    return;
  }

  cardElement.dataset.teamGridInitialized = "true";

  cardElement.addEventListener("click", function (event) {
    const isVisible = cardElement.classList.contains(TEAM_GRID_VISIBLE_CLASS);
    const isLink = cardElement.tagName === "A";
    const canHover =
      window.matchMedia && window.matchMedia("(hover: hover)").matches;

    // On hover capable devices the bio is already revealed by the pointer, so a
    // click on a LinkedIn card should just follow the link.
    if (isLink && canHover) {
      return;
    }

    // The first tap reveals the bio, a second tap follows the LinkedIn link.
    if (isLink && isVisible) {
      return;
    }

    // Once open, clicks inside the bio are for scrolling or selecting text, so
    // leave it open; outside clicks and Escape close it.
    if (isVisible && event.target.closest(".team-grid__card__bio")) {
      return;
    }

    event.preventDefault();
    closeOtherTeamGridCards(cardElement);
    cardElement.classList.toggle(TEAM_GRID_VISIBLE_CLASS, !isVisible);
  });
}

function closeOtherTeamGridCards(currentCard) {
  document
    .querySelectorAll("." + TEAM_GRID_VISIBLE_CLASS)
    .forEach((card) => {
      if (card !== currentCard) {
        card.classList.remove(TEAM_GRID_VISIBLE_CLASS);
      }
    });
}

document.addEventListener("click", function (event) {
  if (event.target.closest && event.target.closest(".team-grid__card")) {
    return;
  }

  closeOtherTeamGridCards(null);
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeOtherTeamGridCards(null);
  }
});
